<template>
    <div class="pageClass">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <NavBar></NavBar>
        <div class="container-fluid p-2">
            <div class="d-flex justify-content-around SearchCondition">
                <div>
                    <span>上課日期</span>
                    <input type="date" v-model="SearchStartDate" />
                    <span>~</span>
                    <input type="date" v-model="SearchEndDate" />
                </div>
                <div>
                    <button class="ShareBTN" data-toggle="modal" data-target="#ChooseGroupModal" @click="SearchRecord()" >
                        查詢
                    </button>
                </div>
            </div>
            <span >{{NoRecordNote}}</span>

            <table class="table AttendanceTable p-2 table-rwd table-bordered" v-if="RecordObjects.length > 0">
                <thead>
                    <tr class="tr-only-hide">
                        <th scope="col">教室編號</th>
                        <th scope="col">課程名稱</th>
                        <th scope="col">上課時間</th>
                        <th scope="col">課程分鐘數</th>
                        <th scope="col">進入教室時間</th>
                        <th scope="col">離開教室時間</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="Record in RecordObjects">
                        <td data-th="教室編號">{{Record.ClassroomId}}</td>
                        <td data-th="課程名稱" >{{Record.LessonName}}</td>
                        <td data-th="上課時間">{{dateFormat(Record.BeginTimeStamp)}}</td>
                        <td data-th="課程分鐘數">{{Record.ClassTime}}</td>
                        <td data-th="進入教室時間">{{dateFormat(Record.EnterClassTimeStamp)}}</td>
                        <td data-th="離開教室時間">{{dateFormat(Record.LeaveClassTimeStamp)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'AttendanceRecord',
    components:{
        NavBar
    },
    data () {
        return {
            Token:'',
            showLoading:false,
            NoRecordNote:'',
            SearchStartDate:moment(new Date()).add(-7, 'days').format('yyyy-MM-DD'),
            SearchEndDate:moment(new Date()).format('yyyy-MM-DD'),
            RecordObjects:[],
        }
    },
    methods:{
        //查詢出勤紀錄
        SearchRecord(){
            if(this.CheckSearchCondition()){
                this.showLoading = true;
                const api =`${process.env.APIPATH}/api/Student/SearchCheckInOutTime`;
                const headers = {"Authorization": 'Bearer '+this.Token};
                const inputdata = 
                {
                    "StartTimeStamp":moment(this.SearchStartDate, 'yyyy-MM-DD ').format("X"),
                    "EndTimeStamp":moment(this.SearchEndDate, 'yyyy-MM-DD ').format("X")
                };

                axios.post(api, inputdata, { headers })
                    .then((response) => {
                        this.showLoading = false;
                        if(response.data.Result){
                            // console.log(response);
                            if(response.data.CheckInOutItems == undefined){
                                this.NoRecordNote ='無出勤紀錄！';
                                this.RecordObjects = [];
                            }
                            else{
                                this.NoRecordNote = '';
                                this.RecordObjects = response.data.CheckInOutItems;
                            }
                        }else{
                            if(response.data.errorCode == 20002){
                                alert("閒置時間過長，請重新進入。");
                            }
                            this.NoRecordNote ='無出勤紀錄！';
                            this.RecordObjects = [];
                        }
                    })
                    .catch(error => {
                        this.RecordObjects = [];
                        this.showLoading = false;
                        this.errorMessage = error.message;
                        console.error("There was an error!", error);
                        alert("取得出勤紀錄失敗："+ error.message);
                    });
            }
        },
        CheckSearchCondition(){
            if(this.SearchEndDate == '' || this.SearchStartDate == ''){
                alert("請輸入選擇查詢日期期間");
                return false;
            }else if(this.SearchEndDate < this.SearchStartDate){
                alert("查詢條件結束日期須大於起始日期");
                return false;
            }else{
                return true;
            }
        },
        // stamp/日期轉換
        dateFormat(timestamp){
            if(timestamp && timestamp != "")
            {
                return moment.unix(timestamp).format("yyyy-MM-DD HH:mm");
            }
            return "";
        },
    },    
    created(){
        this.Token = sessionStorage.getItem('Token');
        this.SearchRecord();
    }
}
</script>





// WEBPACK FOOTER //
// src/components/pages/AttendanceRecord.vue